import React, { useEffect, useState } from 'react';
import './Modals.css';

function AttrModal({ layer, onClose }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const wfsBase = layer.baseUrl.replace('/wms', '/wfs');
    const wfsUrl =
      `${wfsBase}?service=WFS&request=GetFeature` +
      `&typeName=${layer.layers}` +
      `&outputFormat=application/json` +
      `&count=200`;

    const proxyUrl = `/api/wms-proxy?url=${encodeURIComponent(wfsUrl)}`;
    let cancelled = false;

    setLoading(true);
    setError(null);

    fetch(proxyUrl)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (cancelled) return;

        const features = data.features || [];
        if (features.length === 0) {
          setColumns([]);
          setRows([]);
          return;
        }

        // Derive columns from properties of first feature, excluding geometry fields
        const SKIP = ['geometry', 'geom', 'the_geom'];
        const firstProps = features[0].properties || {};
        const cols = Object.keys(firstProps).filter((k) => !SKIP.includes(k));

        const tableRows = features.map((f) => {
          const props = f.properties || {};
          return cols.map((col) => {
            const val = props[col];
            if (val === null || val === undefined) return '—';
            return String(val);
          });
        });

        setColumns(cols);
        setRows(tableRows);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'Erro ao buscar atributos.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [layer]);

  // Close on Escape
  useEffect(() => {
    const handler = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [onClose]);

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal-box modal-box--wide"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Atributos da camada"
      >
        <div className="modal-header">
          <h2 className="modal-title">Atributos — {layer.name}</h2>
          <button className="modal-close" onClick={onClose} aria-label="Fechar">×</button>
        </div>

        <div className="modal-body">
          {loading && (
            <div className="modal-loading">
              <span className="modal-spinner" />
              Carregando atributos…
            </div>
          )}

          {error && !loading && (
            <div className="modal-error">
              <strong>Erro:</strong> {error}
            </div>
          )}

          {!loading && !error && columns.length === 0 && (
            <p className="modal-empty">Nenhuma feição encontrada.</p>
          )}

          {!loading && !error && columns.length > 0 && (
            <>
              <p className="modal-subtitle">
                {rows.length} feição{rows.length !== 1 ? 'ões' : ''} (máx. 200)
              </p>
              <div className="attr-table-wrap">
                <div className="attr-scroll-hint">← scroll →</div>
                <div className="attr-table-scroll">
                  <table className="attr-table">
                    <thead>
                      <tr>
                        {columns.map((col) => (
                          <th key={col}>{col}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, i) => (
                        <tr key={i}>
                          {row.map((cell, j) => (
                            <td key={j}>{cell}</td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AttrModal;
